import { render, staticRenderFns } from "./AdultsPage.vue?vue&type=template&id=117696f0&"
import script from "./AdultsPage.vue?vue&type=script&lang=js&"
export * from "./AdultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports